/* Countdown promo bar — ticks each instance down to its end time.

   The remaining time is anchored to the SHOP's clock, not the visitor's:
   Liquid renders both `data-end` and `data-now` as epoch seconds in the store
   timezone, so we only ever use the browser clock to measure elapsed time.
   A visitor with a badly-set device clock still sees the correct countdown. */
(function () {
  'use strict';

  var PAD = function (n) {
    return n < 10 ? '0' + n : String(n);
  };

  function Bar(root) {
    this.root = root;
    this.timer = root.querySelector('[data-cpb-timer]');
    if (!this.timer) return;

    var end = parseInt(root.getAttribute('data-end'), 10);
    var now = parseInt(root.getAttribute('data-now'), 10);
    if (!end || !now) return;

    this.remaining = end - now; // seconds left at render time
    this.startedAt = Date.now();
    this.expiredAction = root.getAttribute('data-expired') || 'hide';
    this.expiredMessage = root.getAttribute('data-expired-message') || '';
    this.nums = {
      days: this.timer.querySelector('[data-unit="days"] .cpb-num'),
      hours: this.timer.querySelector('[data-unit="hours"] .cpb-num'),
      minutes: this.timer.querySelector('[data-unit="minutes"] .cpb-num'),
      seconds: this.timer.querySelector('[data-unit="seconds"] .cpb-num'),
    };

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  Bar.prototype.tick = function () {
    var elapsed = Math.floor((Date.now() - this.startedAt) / 1000);
    var left = this.remaining - elapsed;

    if (left <= 0) {
      this.stop();
      this.expire();
      return;
    }

    var days = Math.floor(left / 86400);
    var hours = Math.floor((left % 86400) / 3600);
    var minutes = Math.floor((left % 3600) / 60);
    var seconds = left % 60;

    if (this.nums.days) this.nums.days.textContent = PAD(days);
    if (this.nums.hours) this.nums.hours.textContent = PAD(hours);
    if (this.nums.minutes) this.nums.minutes.textContent = PAD(minutes);
    if (this.nums.seconds) this.nums.seconds.textContent = PAD(seconds);
  };

  Bar.prototype.stop = function () {
    if (this.interval) clearInterval(this.interval);
    this.interval = null;
  };

  Bar.prototype.expire = function () {
    if (this.expiredAction === 'hide') {
      this.root.hidden = true;
      return;
    }
    // 'message': swap the timer for the end-of-sale note, keep the banner up
    if (this.expiredMessage) {
      var note = document.createElement('p');
      note.className = 'cpb-heading';
      note.textContent = this.expiredMessage;
      this.timer.parentNode.replaceChild(note, this.timer);
    } else {
      this.timer.hidden = true;
    }
  };

  var instances = [];

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-cpb-root]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__cpb) continue;
      roots[i].__cpb = true;
      instances.push(new Bar(roots[i]));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: sections are re-rendered on every settings change
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i] && e.target.contains(instances[i].root)) instances[i].stop();
    }
  });
})();
